import { Tag, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { DataTable } from "@/shared/components/DataTable";
import { useDevicesList } from "../hooks/useDevices";
import type { Device } from "../types";

const { Title } = Typography;

/**
 * ⚠️ **Amal tugmalari ATAYLAB yo'q** (P3 spec §4) — yoqish/o'chirish
 * `EmployeeDevicesTab`ga ko'chdi (`employeeTabs.tsx`). Bu ro'yxat endi
 * faqat ma'lumotnoma: "kim qaysi qurilmadan foydalanmoqda".
 */
export function DevicesPage() {
	const { t } = useTranslation("devices");
	const query = useDevicesList();

	const columns: ColumnsType<Device> = [
		{
			title: t("columns.deviceUid"),
			dataIndex: "deviceUid",
			key: "deviceUid",
		},
		{
			title: t("columns.employee"),
			dataIndex: "employeeName",
			key: "employeeName",
			render: (value: string | null) => value ?? <span className="text-gray-400">—</span>,
		},
		{
			title: t("columns.model"),
			dataIndex: "model",
			key: "model",
			render: (value: string | null) => value ?? <span className="text-gray-400">—</span>,
		},
		{
			title: t("columns.os"),
			key: "os",
			render: (_, device) =>
				device.os ? (
					<span>
						{device.os}
						{device.osVersion ? ` ${device.osVersion}` : ""}
					</span>
				) : (
					<span className="text-gray-400">—</span>
				),
		},
		{
			title: t("columns.appVersion"),
			dataIndex: "appVersion",
			key: "appVersion",
			render: (value: string | null) => value ?? <span className="text-gray-400">—</span>,
		},
		{
			title: t("columns.lastSeen"),
			dataIndex: "lastSeenAt",
			key: "lastSeenAt",
			render: (value: string | null) =>
				value ? new Date(value).toLocaleString("uz-UZ") : <span className="text-gray-400">—</span>,
		},
		{
			title: t("columns.status"),
			dataIndex: "isActive",
			key: "isActive",
			render: (isActive: boolean) =>
				isActive ? (
					<Tag color="green">{t("status.active")}</Tag>
				) : (
					<Tag color="default">{t("status.inactive")}</Tag>
				),
		},
	];

	return (
		<div>
			<div className="mb-6 flex items-center justify-between gap-4 flex-wrap">
				<Title level={3} className="!mb-0">
					{t("title")}
				</Title>
			</div>

			<DataTable<Device> columns={columns} query={query} />
		</div>
	);
}
